// Smart Sash Admin Panel - Certification Style Utilities
// Shared style utilities for certification components

/**
 * Returns the appropriate background class for form inputs based on edit mode.
 * In edit mode, inputs have a warning-subtle background to indicate they're editable.
 * In view mode, inputs have a light background.
 *
 * @param isEditMode - Whether the form is in edit mode
 * @returns CSS class string for input background
 */
export const getInputBgClass = (isEditMode: boolean): string =>
  isEditMode ? 'bg-warning-subtle' : 'bg-light';
